import type { PictureSet } from "@/lib/images";

type Props = PictureSet & {
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  decoding?: "async" | "sync" | "auto";
};

export function ResponsivePicture({
  avifSrcSet,
  webpSrcSet,
  src,
  sizes,
  width,
  height,
  alt,
  className,
  loading,
  fetchPriority,
  decoding = "async",
}: Props) {
  return (
    <picture>
      <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} />
      <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      <img
        src={src}
        srcSet={webpSrcSet}
        sizes={sizes}
        alt={alt}
        width={width}
        height={height}
        className={className}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding={decoding}
      />
    </picture>
  );
}
